import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { ConfigService, withInject } from '@piwikpro/platform';
import { RouterService } from '@piwikpro/router-crate';
import { useUsersFetchParams } from '../useUsersFetchParams';
import InviteUser from './InviteUser';

interface InviteUserRouteProps {
  config: ConfigService
  userPreferences: any
  routerService: RouterService
}

const InviteUserRoute: React.FC<InviteUserRouteProps> = ({
  config,
  userPreferences,
  routerService,
}) => {
  const navigate = useNavigate();
  const fetchUsersParams = useUsersFetchParams(config, userPreferences);

  return (
    <InviteUser
      fetchUsersParams={fetchUsersParams}
      finish={id => navigate({ to: '/administration/users/$userId', params: { userId: id } })}
      abort={() => routerService.dismissAdministrationOverlay()}
    />
  );
};

export default withInject({
  config: 'config',
  userPreferences: 'userPreferences',
  routerService: 'RouterCrate.router',
})(InviteUserRoute);
